import { Component, OnInit } from '@angular/core';

import {RightContainerService} from '../right-container.service';

@Component({
  selector: 'app-info-crypto-confirmation',
  templateUrl: './info-crypto-confirmation.component.html',
  styleUrls: ['./info-crypto-confirmation.component.scss']
})
export class InfoCryptoConfirmationComponent implements OnInit {

  constructor(private rightContainer: RightContainerService) { }

  ngOnInit() {
  }

}
